import { Tooltip as AntTooltip, TooltipProps } from 'antd'

const Tooltip = (props: TooltipProps) => {
    const { children, ...rest } = props
    return (
        <AntTooltip {...rest}>
            {/** Native HTML element needed for children: https://ant.design/components/tooltip#why-does-the-warning-finddomnode-is-deprecated-some-times-appear-in-strict-mode */}
            <div>{children}</div>
        </AntTooltip>
    )
}

export default Tooltip
